import { render } from "./FoodGathering.vue?vue&type=template&id=225bd8a8&scoped=true"
import script from "./FoodGathering.vue?vue&type=script&lang=js"
export * from "./FoodGathering.vue?vue&type=script&lang=js"

import "./FoodGathering.vue?vue&type=style&index=0&id=225bd8a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225bd8a8"]])

export default __exports__